import { Button, CircularProgress, Container, CssBaseline, Paper, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { ChangeEmailActions, ChangeEmailStoreStates } from '.'

type OwnProps = {}

type ChangeEmailProps = OwnProps & ChangeEmailStoreStates & ChangeEmailActions

const ChangeEmail = (props: ChangeEmailProps) => {
  const { auth } = props
  const { changingEmail, changeEmailError, user } = auth

  const [currentPassword, setCurrentPassword] = useState('')
  const [newEmail, setNewEmail] = useState('')
  const [isEmpty, setIsEmpty] = useState(true)

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (isEmpty) return
    props.changeEmail({ newEmail, currentPassword })
  }

  const updateIsEmpty = () => {
    const state = { currentPassword, newEmail }
    setIsEmpty(Object.values(state).includes(''))
  }

  if (!user) return <></>

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Paper sx={{ p: 2 }}>
        <Typography align="center" color="textPrimary" variant="h5">
          メールアドレスの変更
        </Typography>

        <Typography align="center" color="textSecondary" component="p" variant="subtitle1">
          現在のメールアドレス: {user.email}
        </Typography>

        {changeEmailError && (
          <Typography align="center" color="error" component="h1" variant="h6">
            {changeEmailError}
          </Typography>
        )}

        <form
          noValidate
          style={{
            width: '100%',
            marginTop: '8px',
          }}
          onSubmit={(e) => onSubmit(e)}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="現在のパスワード"
            autoComplete="password"
            type="password"
            autoFocus
            value={currentPassword}
            onChange={({ target }) => {
              setCurrentPassword(target.value)
              updateIsEmpty()
            }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="新しいメールアドレス"
            type="email"
            value={newEmail}
            onChange={({ target }) => {
              setNewEmail(target.value)
              updateIsEmpty()
            }}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={isEmpty || changingEmail}
            sx={{ mt: 3, mb: 2 }}>
            {changingEmail ? <CircularProgress size={20} /> : '変更する'}
          </Button>
        </form>
      </Paper>
    </Container>
  )
}

export default ChangeEmail
